import * as Yup from "yup";

export const enrollmentSchema = Yup.object().shape({
    idMember: Yup.string()
        .required("Aluno é obrigatório"),
    memberName: Yup.string(),
    
    idClass: Yup.string()
        .required("Turma é obrigatória"),
    className: Yup.string(),
    
    idMembership: Yup.string().nullable(), // Null se for avulso ou aula experimental sem plano financeiro ligado
    membershipName: Yup.string().nullable(),
    
    // Desnormalização da Turma e Atividade
    idActivity: Yup.string().nullable(),
    activityName: Yup.string().nullable(),
    idTeacher: Yup.string().nullable(),
    teacherName: Yup.string().nullable(),
    idArea: Yup.string().nullable(),
    area: Yup.string().nullable(),
    
    // Identificação de que tipo é essa matrícula
    type: Yup.string().oneOf(["regular", "trial", "makeup", "single"]).default("regular"),
    sessionDate: Yup.date().nullable(), // Nullável, obrigatório apenas nas lógicas que o "type" não é regular
    
    // Horário e Vaga
    startTime: Yup.string().nullable(),
    endTime: Yup.string().nullable(),
    weekDay: Yup.string().nullable(),
    spotNumber: Yup.number().nullable(),

    
    startDate: Yup.date()
        .required("Data de início na turma é obrigatória"),
    endDate: Yup.date()
        .min(
            Yup.ref('startDate'),
            "A data de término não pode ser anterior à data de início"
        )
        .nullable(), // Permitir nullable para turmas recorrentes "infinitas" baseada no plano
    
    status: Yup.string()
        .oneOf(["active", "paused", "canceled", "completed"])
        .default("active"),
        
    observations: Yup.string().nullable()
});
